module.exports = __webpack_public_path__ + "assets/phone-white.d168c580.svg";